import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, ListGroup, Row, Col } from "reactstrap";

import constants from "../../config/constants";
import List from "./components/List";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import CustomButton from "../../component/CustomButton/CustomButton";
import api from "../../config/api";
import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import employerDetailsAction from "../../redux/employerDetails/action";
import PageHead from "../../component/pageHead/PageHead";
import "./style.css";
import { isNetworkRequestFailedError } from "../../config/helpers";

class EmployerDetails extends Component {
  constructor() {
    super();

    this.state = {
      employerDetailsObj: null,
      employerName: "",
      employerCode: "",
      employerAddress: "",
      correspondenceAddress: "",
      employerData: null,
      isloading: false,
      employerNameQuery: "",
    };
  }

  async componentDidMount() {
    const { history, setHistory, employerDetailsObj } = this.props;

    const promises = [];

    this.setState({ isLoading: true });

    if (!employerDetailsObj) {
      promises.push(this.getEmployeeDetails());
    }

    // if (!employerData) {
    //   promises.push(this.fetchRelationManager());
    // } else {
    //   this.setState({ employerData });
    // }

    await Promise.all(promises);
    this.setState({ isLoading: false });

    setHistory(history);
  }

  fetchRelationManager = async () => {
    const { user, setAlertMessage } = this.props;

    try {
      let employerCode = user.profile.EmployerCode;

      if (user.User.userType === constants.EMPLOYER_CODE) {
        employerCode = user.User.employerCode;
      }

      const response = await api.fetchEmployerData(
        { employerCode },
        user.token
      );

      const data = response.data.result[0];

      this.setState({ employerData: data });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e)
          ? this.fetchRelationManager
          : null,
      });
    }

    return { message: "success" };
  };

  handleChange = (key, e) => {
    const payload = {
      [key]: e.target.value,
    };

    this.setState(payload);
  };

  getEmployeeDetails = async () => {
    const { setAlertMessage, user, setEmployerDetails } = this.props;

    try {
      let employerCode = user.profile.EmployerCode;

      if (user.User.userType === constants.EMPLOYER_CODE) {
        employerCode = user.User.employerCode;
      }

      const response = await api.fetchEmployeeDetails(
        { employerCode },
        user.token
      );

      setEmployerDetails(response.data.result);
      this.setState({ employerDetailsObj: response.data.result });
    } catch (e) {
      setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e)
          ? this.getEmployeeDetails
          : null,
      });
    }

    return { message: "success" };
  };

  renderButtons = () => {
    if (this.state.editing) {
      return (
        <Row className="justify-content-center mb-2">
          <Col md={3} sm={6}>
            <CustomButton
              onClick={this.finishedEditing.bind(this, false)}
              buttonClasses="btn-block"
              buttonText="Cancel"
            />
          </Col>
          <Col md={3} sm={6}>
            <CustomButton
              onClick={this.finishedEditing.bind(this, true)}
              buttonClasses="btn-block"
              buttonText="Save"
            />
          </Col>
        </Row>
      );
    } else {
      return (
        <Row className="justify-content-center mb-2">
          <Col md={3} sm={6}>
            <CustomButton
              onClick={this.startEditing}
              buttonClasses="btn-block"
              buttonText="Edit"
            />
          </Col>
        </Row>
      );
    }
  };

  startEditing = async () => {
    const { employerDetailsObj } = this.props;

    this.setState({
      editing: true,
      employerName: employerDetailsObj.NAME,
      employerCode: employerDetailsObj.RCNO,
      employerAddress: employerDetailsObj.ADDRESS,
      correspondenceAddress: employerDetailsObj.CORRESPONDENCE_ADDRESS,
    });
  };

  finishedEditing = async (shouldSave) => {
    const { user, setAlertMessage } = this.props;

    if (shouldSave) {
      this.setState({ isLoading: true });

      let pin = user.profile.pin;

      if (user.User.userType === constants.EMPLOYER_CODE) {
        pin = user.User.employerCode;
      }

      try {
        const payload = {
          updateDetail: {
            employerName: this.state.employerName,
            employerCode: this.state.employerCode,
            employerAddress: this.state.employerAddress,
            correspondenceAddress: this.state.correspondenceAddress,
          },
        };

        const response = await api.custInformationUpdate(
          payload,
          user.token,
          pin
        );

        setAlertMessage({ type: "success", message: response.data.result });
      } catch (e) {
        setAlertMessage({
          type: "error",
          message: e.message,
          onTryAgain: isNetworkRequestFailedError(e)
            ? () => this.finishedEditing(shouldSave)
            : null,
        });
      }

      this.setState({ isLoading: false });
    }

    this.setState({ editing: false });
  };

  render() {
    const { isLoading, editing, employerNameQuery } = this.state;
    const { employerDetailsObj } = this.props;

    let employerName, employerAddress, correspondenceAddress, employerCode;

    if (employerDetailsObj) {
      employerName = editing
        ? this.state.employerName
        : employerDetailsObj.NAME;
      employerCode = editing
        ? this.state.employerCode
        : employerDetailsObj.RCNO;

      employerAddress = editing
        ? this.state.employerAddress
        : employerDetailsObj.ADDRESS;

      correspondenceAddress = editing
        ? this.state.correspondenceAddress
        : employerDetailsObj.CORRESPONDENCE_ADDRESS;
    }

    return (
      <Container>
        <PageHead
          containerStyles={{ width: "100%" }}
          title="EMPLOYER DETAILS"
        />
        {employerDetailsObj && (
          <ListGroup className="custom-list-container my-2">
            <List
              editing={editing}
              onChange={(e) => {
                this.handleChange("employerName", e);
                this.handleChange("employerNameQuery", e);
              }}
              label="Name:"
              value={employerName}
              queryValue={employerNameQuery}
              onSelect={(item) => {
                this.handleChange("employerName", {
                  target: { value: item["EmployerName"] },
                });
                this.handleChange("employerCode", {
                  target: { value: item["EmployerCode"] },
                });
                this.handleChange("employerNameQuery", {
                  target: { value: "" },
                });
              }}
              compareKey="EmployerName"
              labelKey="EmployerName"
              valueKey="EmployerCode"
              data={this.props.allEmployers}
              type="autocomplete"
            />
            <List label="Code:" value={employerCode} />
            <List label="Phone:" value={employerDetailsObj.PHONE} />
            <List
              editing={editing}
              onChange={this.handleChange.bind(this, "employerAddress")}
              label="Address:"
              value={employerAddress}
            />
            <List
              editing={editing}
              onChange={this.handleChange.bind(this, "correspondenceAddress")}
              label="Correspondence Address:"
              value={correspondenceAddress}
            />
            <List label="Email:" value={employerDetailsObj.EMAIL} />
            {this.renderButtons()}
          </ListGroup>
        )}
        {/* {employerData && (
          <>
            <PageHead
              containerStyles={{ width: "100%" }}
              title="RELATIONSHIP MANAGER DETAILS"
            />
            <ListGroup className="custom-list-container my-2">
              <List
                label="Relationship Manager Name"
                value={employerData.Relationship_Officer_Name}
              />
              <List
                label="Relationship Manager Email"
                value={employerData.Relationship_Officer_Email}
              />
              <List
                label="Relationship Manager Phone"
                value={employerData.Relationship_Officer_Phone}
              />
            </ListGroup>
          </>
        )} */}
        {isLoading && <CustomLoader />}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  employerDetailsObj: state.employerDetails.employerDetailsObj,
  employerData: state.employerDashboard.employerData,
  allEmployers: state.auth.allEmployers,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setAlertMessage: authAction.setAlertMessage,
  setEmployerDetails: employerDetailsAction.setEmployerDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployerDetails);
